import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import SvgSprites from '@/components/layout/seller/SvgSprites.vue';

// Plus de logique de vérification du token
// Tout est maintenant géré côté serveur via cookies HttpOnly

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(SvgSprites),
    _createVNode(_component_router_view)
  ]))
}
}

})